// src/modules/ListLoader.jsx
import React from "react";
import { Box, CircularProgress, Typography, Button } from "@mui/material";

/**
 * Loading + Empty states for lists.
 *
 * <ListLoader loading />
 * <ListLoader empty text="No hymns yet" onAction={...} actionLabel="Add Hymn" />
 */
export function ListLoading({ text = "Loading…" }) {
  return (
    <Box sx={{ p: 6, textAlign: "center" }}>
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>{text}</Typography>
    </Box>
  );
}

export function EmptyState({ text = "Nothing here yet.", actionLabel, onAction }) {
  return (
    <Box sx={{ p: 6, textAlign: "center" }}>
      <Typography sx={{ mb: 2 }}>{text}</Typography>
      {actionLabel && onAction ? (
        <Button variant="contained" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Box>
  );
}

export default function ListLoader({
  loading = false,
  empty = false,
  emptyText,
  onEmptyAction,
  emptyActionLabel,
}) {
  if (loading) return <ListLoading />;
  if (empty) return <EmptyState text={emptyText} onAction={onEmptyAction} actionLabel={emptyActionLabel} />;
  return null;
}
